import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react"

import { useAppSelector } from "../../redux/hooks";
import { classNames, displayNameColoring } from "../../utils/Helpers"
import { useDispatch } from "react-redux";
import { revokeIdentity } from "../../redux/idenTT_Actions";

export const IdentityHeader = () => {
    const dispatch: any = useDispatch()
    const identityState: any = useAppSelector(state => state.identity);

    const signOutHandler = () => {
        dispatch(revokeIdentity())
    }

    return (
        <React.Fragment>
            <Menu as="div" className="relative inline-block text-left float-right">
                {({ open }) => (
                    <>
                        <div className='flex flex-row w-full'>
                            <MenuButton
                                className={
                                    classNames(
                                        open ? 'text-stone-700' : null,
                                        "flex flex-row items-center w-auto md:px-3 px-1 gap-x-3 rounded py-1 text-sm text-stone-500 hover:bg-stone-00 hover:text-stone-700 focus:outline-none focus:ring-0 focus:ring-offset focus:ring-offset-stone-100 focus:ring-green-500 align-middle"
                                    )
                                }>

                                {
                                    !identityState.pic_url ? (
                                        <>
                                            {
                                                identityState.names.display && (
                                                    <div className={`md:w-10 md:h-10 w-10 h-10 flex-none flex items-center justify-center align-middle rounded-full ${displayNameColoring(identityState.names.display.charAt(0))}`}>
                                                        <span className="text-white text-lg font-medium">
                                                            {identityState.names.display.charAt(0)}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </>
                                    ) : (
                                        <img className="rounded-full md:w-9 md:h-9 w-10 h-10 flex-none" src={identityState.pic_url} alt={`${identityState.names.display}'s avatar`} />
                                    )
                                }

                                {/* <span className="text-sm hidden md:flex dark:text-white">{identityState.names.display}</span> */}
                            </MenuButton>
                        </div>

                        <Transition
                            show={open}
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <MenuItems className="w-64 px-1 pb-1 origin-top-right absolute right-0 mt-1 rounded-md shadow-lg bg-white dark:bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="w-full px-3 py-3 flex flex-row items-center gap-x-3 text-sm text-stone-500 hover:bg-stone-00 hover:text-stone-700 align-middle overflow-hidden">
                                    {
                                        !identityState.pic_url ? (
                                            <>
                                                {
                                                    identityState.names.display && (
                                                        <div className={`md:w-10 md:h-10 w-10 h-10 flex-none flex items-center justify-center align-middle rounded-full ${displayNameColoring(identityState.names.display.charAt(0))}`}>
                                                            <span className="text-white text-lg font-medium">
                                                                {identityState.names.display.charAt(0)}
                                                            </span>
                                                        </div>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <img className="rounded-xl md:w-10 md:h-10 w-10 h-10 flex-none" src={identityState.pic_url} alt={`${identityState.names.display}'s avatar`} />
                                        )
                                    }

                                    <div className="flex-grow flex flex-col">
                                        <p className="text-sm text-stone-800 dark:text-white mb-">{identityState.names.display}</p>
                                        <p className="text-xs text-muted">{identityState.email}</p>
                                    </div>
                                </div>

                                <div className="w-full bg-stone-100 dark:bg-slate-700 rounded-lg px-2 py-3 flex flex-col gap-y-1 text-sm">
                                    <MenuItem>
                                        {({ focus }) => (
                                            <Link to={undefined} className={classNames(
                                                focus ? 'bg-stone-200 dark:bg-slate-500 text-stone-800' : 'hover:bg-stone-200 dark:hover:bg-slate-500 hover:shadow-sm text-stone-700 dark:text-slate-300',
                                                "w-full py-2.5 rounded-md px-2 flex items-center justify-center gap-x-2"
                                            )}>
                                                <div className="w-10 flex items-center justify-center">
                                                    <span className="fa-light fa-id-badge fa-lg"></span>
                                                </div>

                                                <div className="flex-1 text-sm">
                                                    <span className="block text-start">My Account</span>
                                                </div>
                                            </Link>
                                        )}
                                    </MenuItem>

                                    <MenuItem>
                                        {({ focus }) => (
                                            <Link to={undefined} className={classNames(
                                                focus ? 'bg-stone-200 dark:bg-slate-600 text-stone-800' : 'hover:bg-stone-200 dark:hover:bg-slate-500 hover:shadow-sm text-stone-700 dark:text-slate-300',
                                                "w-full py-2.5 rounded-md px-2 flex items-center justify-center gap-x-2"
                                            )}>
                                                <div className="w-10 flex items-center justify-center">
                                                    <span className="fa-light fa-circle-info fa-lg"></span>
                                                </div>

                                                <div className="flex-1 text-sm">
                                                    <span className="block text-start">Help</span>
                                                </div>
                                            </Link>
                                        )}
                                    </MenuItem>

                                    <span className="border-b border-stone-300 dark:border-slate-400 pt-0.5 mb-0.5 mx-3"></span>

                                    <MenuItem>
                                        {({ focus }) => (
                                            <button type="button" onClick={signOutHandler} className={classNames(
                                                focus ? 'bg-red-200 text-red-700 dark:hover:bg-slate-500 dark:text-red-900' : 'hover:bg-red-100 dark:hover:bg-slate-500 hover:shadow-sm text-red-600 dark:hover:text-red-900',
                                                "w-full py-2.5 rounded-md px-2 flex items-center justify-center gap-x-2"
                                            )}>
                                                <div className="w-10 flex-none flex items-center justify-center">
                                                    <span className="fa-light fa-sign-out fa-lg"></span>
                                                </div>

                                                <div className="flex-grow text-sm">
                                                    <span className="block text-start">Sign Out</span>
                                                </div>
                                            </button>
                                        )}
                                    </MenuItem>
                                </div>


                            </MenuItems>
                        </Transition>
                    </>
                )}
            </Menu>
        </React.Fragment>
    )
}